<template>
  <div class="widget">
    <h3>公司
      <span class="more" style="cursor: default;">
        <el-pagination
          layout="prev, next"
          :total="total"
          :page-size="10"
          small
          @current-change="getlist"
        ></el-pagination>
      </span>
    </h3>
    <ul>
      <li v-for="item in tableData" :key="item.company_id">
        <router-link :to="`/companycontent/${item.company_id}`" class="w-title">{{ item.company_name }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { getCompanyList } from '@/api'

export default {
  name: 'CompanyWidget',
  data() {
    return { tableData: [], total: 0 }
  },
  created() {
    this.getlist(1)
  },
  methods: {
    getlist(page) {
      getCompanyList({ page, pagesize: 10 }).then((res) => {
        this.tableData = res.data || []
        this.total = res.count || 0
      })
    }
  }
}
</script>
